const Footer = () => {
  return (
    <footer
      style={{
        padding: "20px",
        background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 55%, #db2777 100%)",
        color: "#fff",
        textAlign: "center",
        marginTop: "auto",
      }}
    >
      <h2 style={{ margin: 0, fontSize: "18px" }}>AIO INDIA</h2>
      <p style={{ margin: "6px 0 0", fontSize: "13px", opacity: 0.85 }}>
        Sab kuch, ek jagah — Best deals every day © {new Date().getFullYear()}
      </p>
    </footer>
  );
};

export default Footer;
